import React from 'react'
import styled from 'styled-components'
import media from '../../../styles/media'
import CheckBox from '../../step/checkbox/checkbox'
import validator from 'validator'
import { capitalize } from '../../../utils/helpers'

//Components
import Title from '../../step/title/title'
import Input from '../../step/input/input'
import Button from '../../step/button/button'
import InfoTag from '../../step/infotag/infotag'
import SubTitle from '../../step/title/subtitle'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  ${media.md`
    flex-direction: row; 
    margin-top: 40px;
`};
`

const Feature = styled.button`
  background: transparent;
  border-radius: 45px;
  border: solid 1px #dbdbdb;
  margin-top: 7px;
  margin-bottom: 7px;
  margin-right: 15px;

  cursor: pointer;

  &:focus {
    outline: none;
  }

  ${props => (props.selected ? 'background: #38abe0;  outline: none;' : '')};

  ${media.md`
    margin-top: 15px;
    margin-bottom: 15px;
    margin-right: 30px;
  `};
`

const TextFeature = styled.p`
  margin: 0px;
  opacity: 0.6;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 2.8px;
  text-align: left;
  color: #ffffff;
  padding: 10px 15px;
  ${media.md`
    padding: 20px 30px;
`};
`

class StepSalesChannel extends React.Component {
  state = {
    isError: false,
    active: 0
  }

  _onNextPress = () => {
    const { nextStep, channel, onFormSubmit } = this.props
    if (channel === 0) {
      this.setState({ isError: true })
    } else {
      onFormSubmit()
    }
  }

  _toggleCheckbox = lopd => {
    const { updateLopd } = this.props

    this.setState({ lopd })
    updateLopd(lopd)
  }

  _toggleChannel = active => {
    const { updateChannel } = this.props
    updateChannel(active)
    this.setState({ active })
  }

  _keyPressEnter = event => {
    if (event.key === 'Enter') {
      this._onNextPress()
    }
  }

  render() {
    const { isError, active } = this.state
    const { currentStep, channel, lopd } = this.props
    return 4 != currentStep ? null : (
      <div className="col-md-8 " style={{ margin: 'auto' }}>
        <Title title="¿Tienes un canal de venta en línea?" />
        <div>
          <Feature
            selected={channel == 'Si'}
            onClick={() => this._toggleChannel('Si')}
          >
            <TextFeature>
              <div style={{ width: '100px', textAlign: 'center' }}>Si</div>
            </TextFeature>
          </Feature>
          <Feature
            selected={channel == 'No'}
            onClick={() => this._toggleChannel('No')}
          >
            <TextFeature>
              <div style={{ width: '100px', textAlign: 'center' }}>No</div>
            </TextFeature>
          </Feature>
        </div>

        <div style={{ marginTop: '25px' }}>
          <CheckBox
            label={
              <p>
                Puede conocer más sobre nuestros compromisos con la protección
                de datos personales en:&nbsp;
                <a
                  href="/docs/Politica_de_Proteccion_de_datos-PPM.pdf"
                  target="_blank"
                >
                  Política de privacidad
                </a>
                &nbsp;y{' '}
                <a href="/docs/Politica_de_Cookies-PPM.pdf" target="_blank">
                  Política de Cookies
                </a>
              </p>
            }
            value={lopd}
            checked={lopd}
            onChange={() => this._toggleCheckbox(!lopd)}
          />
        </div>

        <Wrapper style={{ marginTop: '5px' }}>
          <div>
            <Button onClick={this._onNextPress} title="Finalizar" />
          </div>
          {isError ? (
            <InfoTag message="&times; Tranquilo no te agregaremos a ninguna base de llamadas promocionales" />
          ) : null}
        </Wrapper>
      </div>
    )
  }
}

export default StepSalesChannel



// WEBPACK FOOTER //
// ./src/components/contactus/steps/StepSalesChannel.js